// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VbmW","content":"styles_content__1ioF9","tableWrap":"styles_tableWrap__2asLm"};